/* unplugin-vue-components disabled */import { ElTag as __unplugin_components_3 } from 'element-plus/es';import 'element-plus/es/components/tag/style/css';
import { ElButton as __unplugin_components_2 } from 'element-plus/es';import 'element-plus/es/components/button/style/css';
import { ElIcon as __unplugin_components_1 } from 'element-plus/es';import 'element-plus/es/components/icon/style/css';
import __unplugin_components_0 from '~icons/custom/question';
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, isRef as _isRef, createSlots as _createSlots } from "vue";
const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", {
  style: {
    "font-size": "14px",
    "color": "#f19c41"
  },
  class: "marginR10"
}, "使用说明", -1);
const _hoisted_2 = {
  class: "marginR10"
};
const _hoisted_3 = ["href"];
import UTable from '@ultra/share/components/UTable/index.vue';
import { UseTable } from '@ultra/share/components/UTable/useTable';
import ConfigModal from './configModal.vue';
import { useH5PageManage } from './hooks/useH5Page';
import AddEditModal from './addEditModal.vue';
import { apiUsdkGetH5ChannelList } from '@/api/usdk';
import { UseSwitchCommon } from '../hooks';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    const {
      gameInfo
    } = UseSwitchCommon();
    const activeCard = ref('channelH5Config');
    const configModalRef = ref();
    const addEditModal = ref();
    const loginPanes = computed(() => {
      return [{
        title: '渠道H5配置',
        key: 'channelH5Config'
      }, {
        title: 'H5页面管理',
        key: 'h5PageManage'
      }];
    });
    const columns = [{
      label: '渠道名称',
      prop: 'channelTitle'
    }, {
      label: 'H5页面生效数量',
      prop: 'used',
      slot: 'used'
    }];
    const {
      columnsH5,
      tableDataH5,
      tableLoadingH5,
      getH5PageTableData
    } = useH5PageManage();
    const handleClick = (type, row) => {
      addEditModal.value.showModal({
        type,
        data: {
          ...row
        },
        gid: gameInfo.value.Id
      });
    };
    const handleOpenConfig = row => {
      configModalRef.value.showModal({
        data: {
          ...row,
          gid: gameInfo.value.Id
        }
      });
    };
    const handleToH5Page = () => {
      activeCard.value = 'h5PageManage';
      getH5PageTableData({
        gid: gameInfo.value.Id
      });
    };
    // 获取渠道H5配置列表
    const getTableData = async () => {
      const res = await apiUsdkGetH5ChannelList({
        gid: gameInfo.value.Id
      });
      if (res.code === 0) {
        tableData.value = res.data;
      }
    };
    const {
      tableData,
      tableLoading
    } = UseTable(getTableData);
    const handleOpenUrl = () => {
      window.open('https://herogames.feishu.cn/wiki/Mfcvwu8xTiFmKLkZr68cguSUnSg#part-JrSvdANdWoFoHfx5Rm7cESlvnHb', '_blank');
    };
    watch(() => gameInfo.value.Id, () => {
      if (activeCard.value === 'channelH5Config') {
        getTableData();
      }
      if (activeCard.value === 'h5PageManage') {
        getH5PageTableData({
          gid: gameInfo.value.Id
        });
      }
    }, {
      immediate: true
    });
    return (_ctx, _cache) => {
      const _component_i_custom_question = __unplugin_components_0;
      const _component_el_icon = __unplugin_components_1;
      const _component_el_button = __unplugin_components_2;
      const _component_u_card_pane = _resolveComponent("u-card-pane");
      const _component_el_tag = __unplugin_components_3;
      const _component_u_card = _resolveComponent("u-card");
      return _openBlock(), _createBlock(_component_u_card, {
        modelValue: _unref(activeCard),
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _isRef(activeCard) ? activeCard.value = $event : null),
        panes: _unref(loginPanes),
        onBack: getTableData
      }, _createSlots({
        extra: _withCtx(() => [_unref(activeCard) === 'channelH5Config' ? (_openBlock(), _createBlock(_component_el_button, {
          key: 0,
          link: "",
          type: "primary",
          small: "",
          onClick: handleToH5Page
        }, {
          default: _withCtx(() => [_createTextVNode("H5页面管理")]),
          _: 1
        })) : _createCommentVNode("", true), _unref(activeCard) === 'h5PageManage' ? (_openBlock(), _createBlock(_component_el_button, {
          key: 1,
          link: "",
          type: "primary",
          small: "",
          onClick: _cache[0] || (_cache[0] = $event => handleClick('add'))
        }, {
          default: _withCtx(() => [_createTextVNode("新增H5页面")]),
          _: 1
        })) : _createCommentVNode("", true)]),
        default: _withCtx(() => [_createVNode(_component_u_card_pane, {
          name: "channelH5Config"
        }, {
          default: _withCtx(() => [_createVNode(UTable, {
            options: columns,
            "row-key": "cid",
            pagination: "",
            data: _unref(tableData),
            loading: _unref(tableLoading)
          }, {
            used: _withCtx(({
              scope
            }) => [_createElementVNode("span", _hoisted_2, _toDisplayString(scope.row.used) + "/" + _toDisplayString(scope.row.total), 1), _createVNode(_component_el_button, {
              link: "",
              type: "primary",
              small: "",
              onClick: $event => handleOpenConfig(scope.row)
            }, {
              default: _withCtx(() => [_createTextVNode("配置")]),
              _: 2
            }, 1032, ["onClick"])]),
            _: 1
          }, 8, ["data", "loading"])]),
          _: 1
        }), _createVNode(_component_u_card_pane, {
          name: "h5PageManage"
        }, {
          default: _withCtx(() => [_createVNode(UTable, {
            options: _unref(columnsH5),
            "row-key": "cid",
            pagination: "",
            data: _unref(tableDataH5),
            loading: _unref(tableLoadingH5)
          }, {
            webUrl: _withCtx(({
              scope
            }) => [_createElementVNode("a", {
              href: scope.row.webUrl,
              target: "_blank"
            }, _toDisplayString(scope.row.webUrl), 9, _hoisted_3)]),
            orientation: _withCtx(({
              scope
            }) => [_createVNode(_component_el_tag, {
              type: scope.row.orientation === 0 ? '' : 'success'
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(scope.row.orientation === 0 ? '横屏' : '竖屏'), 1)]),
              _: 2
            }, 1032, ["type"])]),
            action: _withCtx(({
              scope
            }) => [_createVNode(_component_el_button, {
              link: "",
              type: "primary",
              small: "",
              onClick: $event => handleClick('edit', scope.row)
            }, {
              default: _withCtx(() => [_createTextVNode("编辑")]),
              _: 2
            }, 1032, ["onClick"])]),
            _: 1
          }, 8, ["options", "data", "loading"])]),
          _: 1
        }), _createVNode(ConfigModal, {
          ref_key: "configModalRef",
          ref: configModalRef,
          onRefresh: getTableData
        }, null, 512), _createVNode(AddEditModal, {
          ref_key: "addEditModal",
          ref: addEditModal,
          onRefresh: _cache[1] || (_cache[1] = $event => _unref(getH5PageTableData)({
            gid: _unref(gameInfo).Id
          }))
        }, null, 512)]),
        _: 2
      }, [_unref(activeCard) === 'channelH5Config' ? {
        name: "left-extra",
        fn: _withCtx(() => [_createElementVNode("div", {
          class: "flex items-center cp",
          onClick: handleOpenUrl
        }, [_hoisted_1, _createVNode(_component_el_icon, {
          size: 20
        }, {
          default: _withCtx(() => [_createVNode(_component_i_custom_question)]),
          _: 1
        })])]),
        key: "0"
      } : undefined]), 1032, ["modelValue", "panes"]);
    };
  }
});